import styled from '@emotion/styled';
import { css } from '@emotion/react';

export type BuyRentTabsWrapperProps = {
    includeHousePrices?: boolean;
};

export const BuyRentTabsWrapper = styled('div')<BuyRentTabsWrapperProps>(
    (props) => {
        const {
            theme: { borderRadius, mq, colors },
            includeHousePrices
        } = props;

        return css`
            width: 100%;
            height: 48px;
            background-color: ${colors['graphic-background-accent-light']};
            border-radius: ${borderRadius['4px']};
            display: flex;

            ${mq.medium} {
                max-width: ${includeHousePrices ? `253px` : `153px`};
            }
        `;
    }
);

export type BuyRentTabProp = {
    isSelected: boolean;
    width: string;
};

export const BuyRentTab = styled('a')<BuyRentTabProp>((props) => {
    const {
        theme: { borderRadius, spacing, colors, mq, focusRing, fontWeight },
        width,
        isSelected
    } = props;

    return css`
        text-decoration: none;
        width: 33.333%;
        border-radius: ${borderRadius['4px']};
        font-size: ${spacing['16px']};
        cursor: pointer;
        font-family: Lato, Helvetica, Arial, sans-serif;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 0;
        outline: none;
        background-color: ${isSelected
            ? colors['graphic-background-contrast']
            : colors['transparent']};
        font-weight: ${isSelected ? fontWeight['bold'] : 'none'};
        color: ${isSelected ? colors.white : colors['grey-steel']};
        white-space: nowrap;

        ${mq.medium} {
            width: ${width};
        }

        &:focus {
            box-shadow: ${focusRing};
            outline: 0;
            z-index: 1;
        }
    `;
});
